<template>
  <div>
    <ul
      id="sow-accordion"
      class="accordion"
      data-accordion
      data-deep-link="true"
      data-allow-all-closed="true"
      data-multi-expand="true"
      data-update-history="true"
      data-deep-link-smudge="500"
    >
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title">
          {{ $t('tender.sow.generalDesc') }}
          <div class="sow-hint">
            <Popover
              :text="$t('tender.sow.generalDescHint')"
              position="bottom-right"
              :width="500"
            />
          </div>
        </a>

        <div
          id="deeplink1"
          class="accordion-content"
          data-tab-content
        >
          <TinymceEditor
            v-model="generalDesc"
            :customizeToolbar="editorToolbar"
          />
        </div>
      </li>
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title">
          {{ $t('tender.sow.generalSpec') }}
          <div class="sow-hint">
            <Popover
              :text="$t('tender.sow.generalSpecHint')"
              position="bottom-right"
              :width="500"
            />
          </div>
        </a>
        <div
          id="deeplink2"
          class="accordion-content"
          data-tab-content
        >
          <TinymceEditor
            v-model="generalSpec"
            :customizeToolbar="editorToolbar"
          />
        </div>
      </li>
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title">
          {{ $t('tender.sow.partiSpec') }}
          <div class="sow-hint">
            <Popover
              :text="$t('tender.sow.partiSpecHint')"
              position="bottom-right"
              :width="500"
            />
          </div>
        </a>
        <div
          id="deeplink3"
          class="accordion-content"
          data-tab-content
        >
          <TinymceEditor
            v-model="particularDesc"
            :customizeToolbar="editorToolbar"
          />
        </div>
      </li>
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title">
          {{ $t('tender.sow.techSpec') }}
          <div class="sow-hint">
            <Popover
              :text="$t('tender.sow.techSpecHint')"
              position="bottom-right"
              :width="500"
            />
          </div>
        </a>
        <div
          id="deeplink4"
          class="accordion-content"
          data-tab-content
        >
          <TinymceEditor
            v-model="technicalDesc"
            :customizeToolbar="editorToolbar"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

import mutationTypes from '@/store/mutation-types'
import Popover from '@/controls/Popover'
import TinymceEditor from '@/controls/TinymceEditor'

export default {
  name: 'ScopeOfWorks',
  components: {
    TinymceEditor,
    Popover,
  },
  data () {
    return {
      accordion: null,
      editorToolbar: ['removeformat undo redo', 'outdent indent', 'forecolor', 'bold italic underline strikethrough blockquote', 'alignleft aligncenter alignright alignjustify', 'hklBulletBList hklNumberedList', 'table', 'fontselect fontsizeselect'],
    }
  },
  computed: {
    ...mapGetters('tenders', {
      currentTender: 'currentTender',
    }),
    generalDesc: {
      get: function () {
        return _.get(this.currentTender, 'general.scopeOfWorks.generalDesc', '')
      },
      set: function (value) {
        this.updateSow('generalDesc', value)
      },
    },
    generalSpec: {
      get: function () {
        return _.get(this.currentTender, 'general.scopeOfWorks.generalSpec', '')
      },
      set: function (value) {
        this.updateSow('generalSpec', value)
      },
    },
    particularDesc: {
      get: function () {
        return _.get(this.currentTender, 'general.scopeOfWorks.particularDesc', '')
      },
      set: function (value) {
        this.updateSow('particularDesc', value)
      },
    },
    technicalDesc: {
      get: function () {
        return _.get(this.currentTender, 'general.scopeOfWorks.technicalDesc', '')
      },
      set: function (value) {
        this.updateSow('technicalDesc', value)
      },
    },
  },
  mounted () {
    if (!this.accordion) {
      this.accordion = new Foundation.Accordion($('#sow-accordion'))
    }
  },
  destroyed () {
    if (this.accordion) {
      this.accordion.destroy()
    }
  },
  methods: {
    ...mapMutations('tenders', {
      updateTenderPathField: mutationTypes.TENDER_UPDATE_PATH_FIELD,
    }),
    updateSow (sowItem, val) {
      this.updateTenderPathField({
        path: ['general', 'scopeOfWorks'],
        newValue: { ...this.currentTender.general.scopeOfWorks, [sowItem]: val },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/accordion';

.sow-hint {
  display: inline-block;
  color: #6e7a91;
  font-size: 14px;
  font-family: Verdana;
  font-style: normal;
}

.tabs-panel {
  .accordion-title, .accordion-content {
    padding-left: 0;
    padding-right: 0;
    font-size: 20px
  }
}
</style>
